/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  FormControl,
  Button,
  Modal,
  ProgressBar,
  Spinner,
  DropdownButton,
  Dropdown
} from 'react-bootstrap';
import CustomBackground from '../../components/UI/CustomBackground/CustomBackground';
import { useTranslation, Translation } from 'react-i18next';
import graphQLClientInstance from '../../axios-graphql-client';
import axios from 'axios';
import Bottleneck from 'bottleneck';
import classes from './MyTests.module.css';
import Table, { tableOrigin } from '../../components/UI/Table/Table';
import { ReactComponent as InfoCircleLightIcon } from '../../assets/infoCircleLight.svg';
import { Formik } from "formik";
import * as Yup from "yup";
import { withRouter } from 'react-router-dom';
import { pdf } from '@react-pdf/renderer';
import { TestDataSheetPDF } from '../../components/PDF/TestDataSheetPDF/TestDataSheetPDF';
import Loader from '../../components/UI/Loader/Loader';
import {
  scrollToRef,
  backgroundImages,
  myTestsReturnTypes,
  expertAdviceOptions,
  getMyTestsQuery,
  testDateBefore,
  overrideStrings,
  API_URLS,
  TABLE_SELECT_ROW,
  isAdvanced,
  testResultsListReturnTypes,
  calcPercentage,
  calcRemaining,
  downloadBlob,
  downloadExcelFileNames,
  downloadExcelWorksheetTitles,
  renderTooltipOverlay,
  downloadPdfFileNames, myTestsPdfPageSizeOptions, getMyTestsPdfPageSizeData
} from '../../shared/utility';
import { generatexlx } from '../../exportXls';
import SearchFormContainer from '../../components/UI/SearchFormContainer/SearchFormContainer';
import ResultsHeader from '../../components/UI/ResultsHeader/ResultsHeader';
import MultiSelect from 'react-multi-select-component';
import CustomDatePicker, { calendarToday } from '../../components/UI/CustomDatePicker/CustomDatePicker';
import IndeterminateCheckbox from '../../components/UI/IndeterminateCheckbox/IndeterminateCheckbox';
import useSettings from '../../hooks/useSettings';
import { ITestDataSheet } from '../../components/TestDataSheet/TestDataSheet';
import { useAlert } from "../../shared/AlertService";
import { useMatomo } from '@datapunt/matomo-tracker-react';
import * as actions from "../../store/actions";
import { connect } from "react-redux";

const MyTests = (props: any) => {
  const { trackPageView } = useMatomo();

  React.useEffect(() => {
    trackPageView({ documentTitle: 'My Tests' });
  }, []);

  const { t } = useTranslation();

  const resultsRef = React.useRef(null);

  const [formValues, setFormValues] = useState({});
  const formValuesRef = React.useRef({});
  formValuesRef.current = formValues;

  const [data, setData] = useState<any[]>([]);
  const dataRef = React.useRef<any[]>();
  dataRef.current = data;

  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const totalCountRef = React.useRef(0);
  totalCountRef.current = totalCount;

  const [pageSize, setPageSize] = useState(0);
  const pageSizeRef = React.useRef(20)
  pageSizeRef.current = pageSize;

  const [pageIndex, setPageIndex] = useState(0);
  const pageIndexRef = React.useRef(0)
  pageIndexRef.current = pageIndex;

  const [sortBy, setSortBy] = useState([]);
  const sortByRef = React.useRef([])
  sortByRef.current = sortBy;

  const [completedPromises, setCompletedPromises] = useState<number>(0);

  const [generateExcel, setGenerateExcel] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [init, setInit] = useState(false);
  const initRef = React.useRef(false);
  initRef.current = init;

  const [excelModalShow, setExcelModalShow] = useState(false);

  const handleExcelModalClose = () => setExcelModalShow(false);
  const handleExcelModalShow = () => setExcelModalShow(true);

  const [completedPromisesTestDatasheets, setCompletedPromisesTestDatasheets] = useState<number>(0);
  const [testDatasheetsModalShow, setTestDatasheetsModalShow] = useState(false);
  const [totalCountTestDatasheets, setTotalCountTestDatasheets] = useState(0);

  const [generatePDF, setGeneratePDF] = useState(false);

  const [testResultsPageSize, ] = useSettings('testDataSheetPageSize', 20);

  const alert = useAlert();

  const fetchData = React.useCallback(({ pageSize: tablePageSize, pageIndex: tablePageIndex, sortBy: tableSortBy, values }) => {
    setData([]);
    setPageSize(tablePageSize);
    setPageIndex(tablePageIndex);
    setSortBy(tableSortBy);
    setIsLoading(true);

    if (pageIndex === 0) {
      setPageCount(0);
      setTotalCount(0);
    }

    graphQLClientInstance.post(API_URLS.TESTS_SEARCH, getMyTestsQuery(values, tablePageSize, tablePageIndex, tableSortBy))
      .then(res => {
        if (res.data.tests_list) {
          setTotalCount(res.data.tests_list[0].totals);
          setPageCount(Math.ceil(res.data.tests_list[0].totals / tablePageSize));
          setData(res.data.tests_list);
        }
        setIsLoading(false);
        if (initRef.current) {
          scrollToRef(resultsRef);
        }
        setInit(true);
      })
      .catch(err => {
        setIsLoading(false);
        console.log(err);
      })
  }, [])


  const limiter = new Bottleneck({
    minTime: 200,
    maxConcurrent: 3,
  });

  const completedPromisesRef = React.useRef(completedPromises);

  const generatePromises = async (sorting: any, values: any, totalItems: number) => {
    completedPromisesRef.current = 0;
    let i = 0;
    let pageIdx = 0;
    const promiseArray: Array<Promise<any>> = [];
    while (i < totalItems) {
      const body = getMyTestsQuery(values, 1000, pageIdx, sorting);
      const promise = limiter.schedule(() => graphQLClientInstance.post(API_URLS.TESTS_SEARCH, body))
      promiseArray.push(promise);
      i += 1000;
      pageIdx++;
    }

    let dataArr: Array<any> = [];
    await axios.all(promiseArray)
      .then(axios.spread((...res) => {
        dataArr = res.map(r => r.data.tests_list);
      }))
    return dataArr;
  };

  const completedPromisesCounter = (count: number) => {
    completedPromisesRef.current = count;
    setCompletedPromises(count);
  };

  // state to keep track of resolved promises
  limiter.on("done", function (info) {
    completedPromisesCounter(completedPromisesRef.current + 1);
  });

  const downloadExcelFile = async ({ values }: { values: any }) => {
    setGenerateExcel(false);
    let myData: any[] = [];
    await generatePromises(sortByRef.current, values, totalCountRef.current)
      .then((res) => {
        if (res) {
          myData = res;
        }
      })
      .catch((err) => {
        console.log(err);
      });

    const flattenData: any[] = myData.flat(2);
    let file = "";
    setGenerateExcel(true);
    file = await generatexlx(
      flattenData,
      [
        myTestsReturnTypes.DENOMINATION,
        myTestsReturnTypes.TEST_ID,
        myTestsReturnTypes.SPECIES_LATIN_NAME,
        myTestsReturnTypes.TEST_DATE,
        myTestsReturnTypes.BATCH_NAME,
        myTestsReturnTypes.ADVICE,
        myTestsReturnTypes.TEST_STATUS
      ],
      downloadExcelWorksheetTitles.MY_TESTS_WORKSHEET
    ).catch((err) => {
      console.log(err);
    });

    if (file) {
      const blob = new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      downloadBlob(blob, downloadExcelFileNames.MY_TESTS);
    }
    setExcelModalShow(false);
  };

  const limiterTestDatasheets = new Bottleneck({
    minTime: 200,
    maxConcurrent: 3,
  });

  const compareTestResultsList = (a: any, b: any) => {
    let comparison = 0;
    if (a[testResultsListReturnTypes.SCORE] > b[testResultsListReturnTypes.SCORE]) {
      comparison = 1;
    } else if (a[testResultsListReturnTypes.SCORE] < b[testResultsListReturnTypes.SCORE]) {
      comparison = -1;
    }
    return comparison;
  }

  const completedPromisesTestDatasheetsRef = React.useRef(completedPromisesTestDatasheets);

  const generatePromisesTestDatasheets = async (ids: number[]) => {
    completedPromisesTestDatasheetsRef.current = 0;
    const promiseArray: Array<Promise<any>> = [];
    ids.forEach((testId: number) => {
      const promise = limiterTestDatasheets.schedule(() => graphQLClientInstance.get(`api/v1/tests/${testId}`))
      promiseArray.push(promise);
    })

    const dataArr: Array<any> = [];
    await axios.all(promiseArray)
      .then(axios.spread((...res) => {
        res.forEach(r => {
          const testResultsData = r.data.testresults_list;
          if (testResultsData.length) {
            testResultsData.sort(compareTestResultsList);
            dataArr[testResultsData[0][testResultsListReturnTypes.TEST_ID]] = testResultsData;
          }
        });
      }))
    return dataArr;
  };

  const completedPromisesTestDatasheetsCounter = (count: number) => {
    completedPromisesTestDatasheetsRef.current = count;
    setCompletedPromisesTestDatasheets(count);
  };

  // state to keep track of resolved promises
  limiterTestDatasheets.on("done", function (info) {
    completedPromisesTestDatasheetsCounter(completedPromisesTestDatasheetsRef.current + 1);
  });

  const [showTrademarksOption, setShowTrademarksOption] = useState(false);
  const [myTestsPdfPageSizeKey, setMyTestsPdfPageSizeKey] = useState(getMyTestsPdfPageSizeData().key);
  const [selectedTableData, setSelectedTableData] = useState({ data: []});
  const downloadTestResults = async ({ data: testResults }: { data: any }) => {
    completedPromisesTestDatasheetsCounter(0);
    setGeneratePDF(true);

    const testIds = testResults.map((test: any) => test.testid);

    let testResultsData: any[] = [];
    await generatePromisesTestDatasheets(testIds)
        .then((res) => {
          if (res) {
            testResultsData = res;
          }
        })
        .catch((err) => {
          console.log(err);
        });

    const myTestsPdfPageSize = getMyTestsPdfPageSizeData(myTestsPdfPageSizeKey).size;

    const testDatasheetsData = testResults.map((datasheet: any) => {
      let testResultsDenominationsData = testResultsData[datasheet['testid']] ?
          [...testResultsData[datasheet['testid']].filter((result: any) => result[testResultsListReturnTypes.EUTM] === 0)]
          : [];
      let testResultsEutmData = testResultsData[datasheet['testid']] ?
          [...testResultsData[datasheet['testid']].filter((result: any) => result[testResultsListReturnTypes.EUTM] === 1)]
          : [];

      if (myTestsPdfPageSize > 0) {
        testResultsDenominationsData = testResultsDenominationsData.slice(0, myTestsPdfPageSize);
        testResultsEutmData = testResultsEutmData.slice(0, myTestsPdfPageSize);
      }

      let datasheetObj: ITestDataSheet = {
        ...datasheet,
        species_id: datasheet['specieid'],
        class_code: datasheet['class_code'],
        test_id: datasheet['testid'],
        breeder_name: datasheet['breedername'],
        breeder_ref: datasheet['breederreference'],
        species_latin_name: datasheet['species_name'],
        test_results: {
          denominations: [...testResultsDenominationsData],
        }
      };

      if (showTrademarksOption) {
        datasheetObj.test_results.eutm = [...testResultsEutmData];
      }

      return datasheetObj;
    });

    // @ts-ignore
    const myPdf = pdf({});
    // @ts-ignore
    myPdf.updateContainer(<TestDataSheetPDF data={testDatasheetsData} />);
    myPdf.toBlob().then((blob: any) => {
      downloadBlob(blob, downloadPdfFileNames.MY_TESTS);
    }).finally(() => closeDownloadTestsModal());

  };

  const selectedData = React.useCallback(({ data: selectedData }) => {
    if (selectedData.length) {
      setTotalCountTestDatasheets(selectedData.length);
      setSelectedTableData({ data: selectedData });
      setTestDatasheetsModalShow(true);
    }
  }, []);

  const closeDownloadTestsModal = () => {
    setTestDatasheetsModalShow(false);
    setShowTrademarksOption(false);
    setMyTestsPdfPageSizeKey(getMyTestsPdfPageSizeData().key);
    setGeneratePDF(false);
  };

  useEffect(() => {
    if (completedPromises) {
      handleExcelModalShow();
    }
  }, [completedPromises])

  const downloadExcel = React.useCallback(({ values }) => {
    downloadExcelFile({ values: values });
  }, []);

  const initialSelectedColumns = [
    {
      name: myTestsReturnTypes.DENOMINATION,
      label: <Translation>{(translate) => translate('denomination')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 0
    },
    {
      name: myTestsReturnTypes.TEST_ID,
      label: <Translation>{(translate) => translate('test_id')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 2
    },
    {
      name: myTestsReturnTypes.SPECIES_LATIN_NAME,
      label: <Translation>{(translate) => translate('species_latin_name')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 3
    },
    {
      name: myTestsReturnTypes.BREEDER_REFERENCE,
      label: <Translation>{(translate) => translate('breeders_reference')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 4
    },
    {
      name: myTestsReturnTypes.TEST_DATE,
      label: <Translation>{(translate) => translate('test_date')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 5,
      sortDescFirst: true
    },
    {
      name: myTestsReturnTypes.BATCH_NAME,
      label: <Translation>{(translate) => translate('batch')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 6,
    },
    {
      name: myTestsReturnTypes.REQUEST_ADVICE_ID,
      label: <Translation>{(translate) => translate('advice')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 7
    },
    {
      name: myTestsReturnTypes.CONTACT_NAME,
      label: <Translation>{(translate) => translate('contact_name')}</Translation>,
      // @ts-ignore
      enabled: formValuesRef.current?.testsOrganization,
      isDefault: false,
      defaultOrder: 7,
      disableSortBy: true
    },
    {
      name: myTestsReturnTypes.TEST_STATUS,
      label: <Translation>{(translate) => translate('status')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 9
    }
  ];

  const initialValues: { [key: string]: any } = {
    denomination: "",
    speciesLatinName: "",
    batchName: "",
    expertAdvice: [],
    testDate: [],
    archivedTests: false,
    testsOrganization: false
  };

  const changeTestStatus = (evt: React.SyntheticEvent, setFieldValue: any, currentValue: any) => setFieldValue("archivedTests", !currentValue)

  const form = (
    <Formik
      initialValues={initialValues}

      validationSchema={Yup.object().shape({
        testDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed().oneOf(['to', 'from'] as const).required(),
              value: Yup.string().required()
            })
          ).test("isDateAfter", t("error_messages.date_before"), testDateBefore),
      })}
      onSubmit={(values: any, { setFieldValue, setSubmitting }) => {
        const payload = {
          ...values
        };
        setPageIndex(0);
        setFormValues(payload);
        setSubmitting(false);
        setIsLoading(true);
      }
      }>
      {formProps => (
        <Form
          className={classes.searchForm}
          onSubmit={(e) => {
            formProps.handleSubmit();
            e.preventDefault();
          }}>
          <Row className={[classes.searchFieldsRow, classes.rowPadBottom0].join(" ")}>
            <Col md="4" id="denominationContainer">
              <Form.Group controlId="searchForm.denomination">
                <Form.Label className="w-100">
                  {t("denomination")}
                  {renderTooltipOverlay(
                    t("tooltips_my_tests.denomination"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <FormControl
                  name='denomination'
                  as="input"
                  type="text"
                  value={formProps.values.denomination}
                  onChange={formProps.handleChange}
                />
              </Form.Group>
            </Col>
            <Col md="8" id="speciesLatinNameContainer">
              <Form.Group controlId="searchForm.speciesLatinName">
                <Form.Label className="w-100">
                  {t("species_latin_name")}
                  {renderTooltipOverlay(
                    t("tooltips_my_tests.species_latin_name"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <FormControl
                  name='speciesLatinName'
                  as="input"
                  type="text"
                  value={formProps.values.speciesLatinName}
                  onChange={formProps.handleChange}
                />
              </Form.Group>
            </Col>
            <Col md="4" id="batchNameContainer">
              <Form.Group controlId="searchForm.batchName">
                <Form.Label className="w-100">
                  {t("batch")}
                  {renderTooltipOverlay(
                    t("tooltips_my_tests.batch"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <FormControl
                  name='batchName'
                  as="input"
                  type="text"
                  value={formProps.values.batchName}
                  onChange={formProps.handleChange}
                />
              </Form.Group>
            </Col>
            {isAdvanced() &&
            <Col md="4" id="expertAdviceContainer">
                <Form.Group controlId="searchForm.expertAdvice">
                    <Form.Label className="w-100">
                      {t("cpvo_expert_advice")}
                      {renderTooltipOverlay(
                          t("tooltips_my_tests.cpvo_expert_advice"),
                          <InfoCircleLightIcon/>
                      )}
                    </Form.Label>
                    <MultiSelect
                        onChange={(val: any) => formProps.setFieldValue("expertAdvice", val)}
                        value={formProps.values.expertAdvice}
                        className="customMultiSelect"
                        options={expertAdviceOptions()}
                        disableSearch={true}
                        overrideStrings={overrideStrings()}
                        labelledBy="expertAdvice"/>
                </Form.Group>
            </Col>
            }
            <Col md="4" id="testDateContainer">
              <Form.Group>
                <Form.Label className="w-100">
                  {t("test_date")}
                  {renderTooltipOverlay(
                    t("tooltips_my_tests.test_date"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <CustomDatePicker
                  maximumDate={calendarToday()}
                  name="testDate"
                  controlId="searchForm.testDate"
                  setFieldValue={formProps.setFieldValue}
                  value={formProps.values.testDate}
                  invalid={formProps.errors.testDate && formProps.touched.testDate}
                />
                <Form.Control.Feedback type="invalid">
                  {formProps.errors.testDate}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className={[classes.searchFieldsRow, classes.rowPadTop0].join(" ")}>
            <Col md="4" id="archivedTestsContainer">
              <Form.Group controlId="searchForm.archivedTests">
                <div>
                  <span className="d-inline" style={{ cursor: 'default' }}>
                    {t("status")}
                    <span
                      onClick={(evt: React.SyntheticEvent) => changeTestStatus(evt, formProps.setFieldValue, formProps.values.archivedTests)}
                      style={{ cursor: 'pointer', marginLeft: '6px' }}
                    >
                    </span>
                  </span>
                  <div
                    className="d-inline custom-control custom-switch"
                    onClick={(evt: React.SyntheticEvent) => changeTestStatus(evt, formProps.setFieldValue, formProps.values.archivedTests)}>
                    <input
                      type="checkbox"
                      id="archivedTests"
                      name="archivedTests"
                      className="custom-control-input"
                      onChange={() => { return }}
                      checked={!formProps.values.archivedTests}
                    />
                    <label
                      title=""
                      htmlFor="custom-switch"
                      className={["custom-control-label", classes.toggleLabel].join(" ")}
                      style={{ cursor: 'pointer', width: '28px', height: '16px' }} />
                  </div>
                  <div style={{ fontSize: '12px' }}>
                    {t("status_subheading")} <strong>{(formProps.values.archivedTests) ? t("archived_tests_only") : t("active_tests_only")}</strong>
                  </div>
                </div>
              </Form.Group>
            </Col>
            <Col md="4" id="testsOrganizationContainer">
              <Form.Group controlId="searchForm.testsOrganization">
                <Form.Check
                  type="checkbox"
                  name="testsOrganization"
                  label={t("my_organization_tests")}
                  checked={formProps.values.testsOrganization}
                  onChange={(evt: React.SyntheticEvent) => formProps.setFieldValue("testsOrganization", (evt.target as HTMLInputElement).checked)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className={classes.actionsRow}>
            <Col md="12">
              <Button id="submitSearchForm" variant="primary" type="submit" disabled={formProps.isSubmitting} className="float-right">{t("search")}</Button>
              <Button id="clearFields" variant="link" onClick={() => formProps.resetForm()} className="float-right mr-2">{t("clear_fields")}</Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );

  const tableColumns = React.useMemo(() => {
    return [
      {
        id: TABLE_SELECT_ROW,
        Header: ({ getToggleAllRowsSelectedProps }: { getToggleAllRowsSelectedProps: any }) => (
          <div>
            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({ row }: { row: any }) => (
          <div>
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        ),
      },
      {
        name: myTestsReturnTypes.USER_INPUT_NEEDED,
        label: "",
        accessor: myTestsReturnTypes.USER_INPUT_NEEDED,
        Header: "",
        enabled: true,
        disableSortBy: true
      },
      ...initialSelectedColumns
          .filter((item: any) => isAdvanced() || item.name !== myTestsReturnTypes.REQUEST_ADVICE_ID)
          .map((item: any) => { return { ...item, Header: item.label, accessor: item.name,
          } })
    ]
  }, [initialSelectedColumns]);

  const downloadExcelModal = (
    <Modal
      centered
      keyboard={false}
      backdrop="static"
      show={excelModalShow}
      onHide={handleExcelModalClose}
    >
      <Modal.Header>
        <Modal.Title>
          {t('downloading_results')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProgressBar
          className="w-100"
          now={calcPercentage(completedPromises, (totalCount / 1000))}
          label={`${calcPercentage(completedPromises, (totalCount / 1000))}%`} />
        <br></br>
        <div>
          {t("results_downloaded_counter", { current: calcRemaining((completedPromises * 1000), totalCount), total: totalCount })}
        </div>
        <div>
          {generateExcel ?
            <>
              {t("generate_excel")} <Spinner animation="border" size="sm" variant="primary" />
            </>
            : ""}
        </div>
      </Modal.Body>
    </Modal>
  )

  const downloadTestDatasheetsModal = (
    <Modal
      centered
      keyboard={false}
      backdrop="static"
      show={testDatasheetsModalShow}
      onHide={() => setTestDatasheetsModalShow(false)}
    >
      <Modal.Header>
        <Modal.Title>
          {t('download_myTests_pdf')}
        </Modal.Title>
      </Modal.Header>
      {!generatePDF &&
      <>
        <Modal.Body>
            <div>
                <p>{t("download_myTests_modal_msg_1")}</p>
                <p>{t("download_myTests_modal_msg_2")}</p>
            </div>
            <Row>
                <Col md="6">
                    <DropdownButton
                        id="myTestsPdfModalDropdown"
                        variant="myTests-dropdown"
                        className={classes.myTestsDropdown}
                        title={getMyTestsPdfPageSizeData(myTestsPdfPageSizeKey).label}
                        onSelect={(eventKey: any, event: Object) => setMyTestsPdfPageSizeKey(eventKey)}>
                      {myTestsPdfPageSizeOptions().map((item: any) => {
                        return <Dropdown.Item key={item.key} eventKey={item.key}>{item.label}</Dropdown.Item>
                      })}
                    </DropdownButton>
                </Col>
                <Col md="6" className={classes.showTrademarksCol}>
                    <div>
                        <input
                            type="checkbox"
                            id="showEutm"
                            checked={showTrademarksOption}
                            onChange={(evt: React.SyntheticEvent) => setShowTrademarksOption((evt.target as HTMLInputElement).checked)}
                        />
                        <label htmlFor="showEutm">
                          {t("show_eutm_option")}
                        </label>
                    </div>
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-primary" onClick={closeDownloadTestsModal}>{t("cancel")}</Button>
            <Button id="downloadMyTestsPdf" variant="primary"
                    onClick={() => downloadTestResults(selectedTableData)}>{t("download_pdf")}</Button>
        </Modal.Footer>
      </>
      }
      <Modal.Body style={{display: generatePDF ? 'block' : 'none'}}>
            <ProgressBar
                min={0}
                max={totalCountTestDatasheets}
                now={completedPromisesTestDatasheetsRef.current}
                label={`${calcPercentage(completedPromisesTestDatasheetsRef.current, totalCountTestDatasheets)}%`}/>
            <br></br>
            <div>
              {t("results_downloaded_counter", {
                current: completedPromisesTestDatasheetsRef.current,
                total: totalCountTestDatasheets
              })}
            </div>
            {generatePDF && <div>{t("generate_pdf")} <Spinner animation="border" size="sm" variant="primary"/></div>}
      </Modal.Body>
    </Modal>
  )

  const requestBulkAdvice = React.useCallback(({ data: ids }) => {
    const isAdvancedUser = isAdvanced();

    if (isAdvancedUser && ids.length) {
      setIsLoading(true);
      graphQLClientInstance.post(API_URLS.TESTS_ADVICE_REQUEST, { "test_ids": ids })
        .then(res => {
          setIsLoading(false);
          if (res.data?.response === "OK") {
            if (dataRef.current) {
              const updatedData = [...dataRef.current];
              ids.forEach((item: number) => {
                updatedData.forEach((d: any, i: number) => {
                  if (d.testid === item) {
                    updatedData[i].request_advice_id = 2;
                  }
                });
              })
              // @ts-ignore
              setData(updatedData);
              dataRef.current = updatedData;
            }
          } else if (res.data?.response) {
            alert({
              catchOnCancel: false,
              title: t("alert"),
              body: t(`error_messages.${res.data.response}`)
            })
          }
        })
        .catch(err => {
          setIsLoading(false);
          console.log(err);
        });
    }
  }, [])

  const refreshData = () => {
    fetchData({
      pageIndex: pageIndexRef.current,
      pageSize: pageSizeRef.current,
      sortBy: sortByRef.current,
      values: formValuesRef.current
    });
  }

  const deleteTests = React.useCallback(({ data: ids }) => {
    if (ids.length) {
      alert({
        catchOnCancel: false,
        title: t("alert"),
        body: t("my_tests.delete_test_message"),
        alertVariant: "confirmation",
      }).then(() => {
        setIsLoading(true);
        graphQLClientInstance.post(API_URLS.TESTS_DELETE, { "test_ids": ids })
          .then(res => {
            setIsLoading(false);
            if (res.data.response && res.data.response.includes("test_ids_deleted")) {
              props.onRemoveTestDenomination(ids);
              refreshData();
            } else if (res.data.response) {
              alert({
                catchOnCancel: false,
                title: t("alert"),
                body: t(`error_messages.${res.data.response}`)
              })
            }
          })
          .catch(err => {
            setIsLoading(false);
            console.log(err);
          });
      })
    }
  }, [])

  const archiveTests = React.useCallback(({ data: ids }) => {
    if (ids.length) {
      alert({
        catchOnCancel: false,
        title: t("alert"),
        body: t("my_tests.archive_test_message"),
        alertVariant: "confirmation",
      }).then(() => {
        setIsLoading(true);
        graphQLClientInstance.post(API_URLS.TESTS_ARCHIVE, { "test_ids": ids })
          .then(res => {
            setIsLoading(false);
            if (res.data.response && res.data.response.includes("test_ids_archived")) {
              refreshData();
            } else if (res.data.response) {
              alert({
                catchOnCancel: false,
                title: t("alert"),
                body: t(`error_messages.${res.data.response}`)
              })
            }
          })
          .catch(err => {
            setIsLoading(false);
            console.log(err);
          });
      })
    }
  }, [])

  const updateReqAdvice = (testId: number, adviceId: number, adviceRequestDate: number | null, adviceRequestedBy: string | number | null) => {
    if (dataRef.current) {
      const updatedData = [...dataRef.current];
      updatedData.forEach((item: any, i: number) => {
        if (item.testid === testId) {
          updatedData[i].request_advice_id = adviceId;
          updatedData[i].advice_request_date = adviceRequestDate;
          updatedData[i].advice_requested_by = adviceRequestedBy;
        }
      })
      setData(updatedData);
    }
  }

  return (
    <>
      <Loader show={isLoading}></Loader>
      <CustomBackground image={backgroundImages.MY_TESTS}>
        <SearchFormContainer
          title={t("my_tests.title")}
          subtitle={t("my_tests.subtitle")}
        >
          {form}
        </SearchFormContainer>
      </CustomBackground>
      <Container fluid style={{ display: !(isLoading && totalCount === 0) ? 'block' : 'none' }} className={classes.myTestsTable}>
        <ResultsHeader
          totalCount={totalCount}
          resultsRef={resultsRef}
        />
        <Table
          columns={tableColumns}
          origin={tableOrigin.MY_TESTS}
          initialSortBy={[{ "id": myTestsReturnTypes.TEST_DATE, desc: true }]}
          hideColumnsButton={true}
          isSortable={true}
          data={data}
          fetchData={fetchData}
          downloadExcel={downloadExcel}
          requestBulkAdvice={requestBulkAdvice}
          selectedData={selectedData}
          deleteTests={deleteTests}
          archiveTests={archiveTests}
          pageCount={pageCount}
          totalCount={totalCount}
          pageIndex={pageIndex}
          formValues={formValues}
          showPagination={true}
          updateReqAdvice={updateReqAdvice}
          pageSizeOptions={[5, 10, 20, 25, 50, 100]}
        />
        {downloadExcelModal}
        {downloadTestDatasheetsModal}
      </Container>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    testDenominations: state.testDenominations.tests
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRemoveTestDenomination: (test_ids: any[]) => dispatch(actions.removeTestDenominations(test_ids)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MyTests));
